import type { UUID } from "utils";

export const BASE_URL = "/payments/transactions";

export const PAGE_URLS = {
  list: `${BASE_URL}`,
  details: `${BASE_URL}/:id`,
  notification: `${BASE_URL}/:id/notifications`,
  getLinkToDetails: (id: UUID) => `${BASE_URL}/${id}`,
  getLinkToNotifications: (id: UUID) => `${BASE_URL}/${id}/notifications`,
  getLinkToRefundList: (transactionId: UUID) =>
    `${BASE_URL}/${transactionId}/refunds`,
  refundsList: `${BASE_URL}/:id/refunds`,
  getLinkToTransactionRefunds: (id: UUID) => `${BASE_URL}/${id}/refunds`,
  getLinkToRefundsFilteredByTransaction: (transactionId: UUID) =>
    `/payments/refunds?transactionId=${transactionId}`,
} as const;
